import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EstadoDocumentoItem, EstadoSolicitudItem, SolicitudSeccion } from 'src/app/models/common/enumModel';
import { ISolicitudVehiculoModel } from 'src/app/models/interfaces/solicitud/ISolicitudVehiculoModel';
import { ISolicitudVehiculoValidarModel } from 'src/app/models/interfaces/solicitud/vehiculos/ISolicitudVehiculoValidarModel';
import { ChoferModel } from 'src/app/models/solicitud/ChoferModel';
import { DocumentacionRequeridaModel } from 'src/app/models/solicitud/DocumentacionRequeridaModel';
import { SolicitudDocumentoModel } from 'src/app/models/solicitud/documento/SolicitudDocumentoModel';
import { VehiculoModel } from 'src/app/models/solicitud/VehiculoModel';
import { SolicitudVehiculoValidarModel } from 'src/app/models/solicitud/vehiculos/SolicitudVehiculoValidarModel';
import { SolicitudVehiculoDocumentosService } from 'src/app/services/solicitud-vehiculo-documentos/solicitud-vehiculo-documentos.service';
import { SolicitudVehiculoService } from 'src/app/services/solicitud-vehiculo/solicitud-vehiculo.service';
import * as fileSaver from 'file-saver';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { VisorPdfDialogComponent } from 'src/app/components/shared/visor-pdf-dialog/visor-pdf-dialog.component';
import { VisorPdfDocumentoModel } from 'src/app/models/common/VisorPdfDocumentoModel';

@Component({
  selector: 'app-validar-vehiculo-dialog',
  templateUrl: './validar-vehiculo-dialog.component.html',
  styleUrls: ['./validar-vehiculo-dialog.component.css']
})
export class ValidarVehiculoDialogComponent implements OnInit {
  model!: ISolicitudVehiculoModel;
  modelVehiculo: ISolicitudVehiculoValidarModel;
  displayedColumns: string[] = [
    'nombre',
    'idRequisito',
    'fechaVencimiento',
    'idDocumento',
    'aprobado',
    'observado'
  ];

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ValidarVehiculoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ISolicitudVehiculoModel,
    private solicitudVehiculoService: SolicitudVehiculoService,
    private solicitudVehiculoDocumentoService: SolicitudVehiculoDocumentosService,
    private alertDialogService: AlertDialogService,
  ) {
    this.model = new VehiculoModel();
    this.modelVehiculo = new SolicitudVehiculoValidarModel();
  }

  ngOnInit(): void {
    this.solicitudVehiculoService.getById(this.data.idSolicitud, this.data.idSolicitudVehiculo).subscribe(p => {
      // console.log(p);
      this.model = p;
      this.model.idSolicitud = this.data.idSolicitud;
      this.model.codigoSolicitud = this.data.codigoSolicitud;
      this.model.logs = this.model.logs.filter(p => p.comentarios != "" && p.comentarios != null);

      this.model.documentos.forEach((p) => {
        p.aprobado = p.idEstado === EstadoDocumentoItem.APROBADO;
        p.observado = p.idEstado === EstadoDocumentoItem.OBSERVADO;
      });

      if (!this.model.solicitudChofer) {
        this.model.solicitudChofer = new ChoferModel();
      }

      this.modelVehiculo.idSolicitudVehiculo = this.data.idSolicitudVehiculo;
      //this.modelVehiculo.comentarios = this.data.comentarios;
      this.modelVehiculo.idEstado = this.data.idEstado;
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  enviar() {
    let pendientes = this.model.documentos.filter(
      (p) => !p.aprobado && !p.observado
    ).length;

    let pendientesObservados = this.model.documentos.filter(
      (p) => p.observado
    ).length;

    // console.log(this.modelEquipo);
    if (pendientes == 0 && pendientesObservados >= 1 && (this.modelVehiculo.comentarios == '' || !this.modelVehiculo.comentarios)) {
      this.alertDialogService.open('Debe ingresar un comentario');
    } else {
      this.model.documentos.forEach(p => {
        let documento = new SolicitudDocumentoModel();
        documento.idDocumento = p.idSolicitudVehiculoDocumento;
        if (p.aprobado) {
          documento.idEstado = EstadoDocumentoItem.APROBADO;
        }
        else if (p.observado) {
          documento.idEstado = EstadoDocumentoItem.OBSERVADO;
        }
        else {
          documento.idEstado = EstadoDocumentoItem.PENDIENTE;
        }

        this.modelVehiculo.documentos.push(documento);
      });
      // console.log(this.modelPersona);
      this.solicitudVehiculoService.validar(this.modelVehiculo).subscribe(p => {
        if (pendientes == 0) {
          if (pendientesObservados > 0)
            this.alertDialogService.open('Se registró su observación y se notificó al contratista');
          else
            this.alertDialogService.open('Se registró su aprobación');
          this.alertDialogService.closed().subscribe((confirmed) => {
            this.dialogRef.close(true);
          });
        }
        else
          this.dialogRef.close(true);
      });
    }
  }

  changeAprobado(element: DocumentacionRequeridaModel) {
    if (element.aprobado) element.observado = false;
  }

  changeObservado(element: DocumentacionRequeridaModel) {
    if (element.observado) element.aprobado = false;
  }

  downloadDocumentFromService(element: DocumentacionRequeridaModel) {

    if (element.permiteVisor) {
      let modelVisor: VisorPdfDocumentoModel = new VisorPdfDocumentoModel();
      modelVisor.seccion = SolicitudSeccion.Vehiculos;
      modelVisor.idRegistro = this.modelVehiculo.idSolicitudVehiculo;
      modelVisor.idSolicitudDocumento = element.idSolicitudVehiculoDocumento;
      modelVisor.codigoSolicitud = this.model.codigoSolicitud;
      modelVisor.nombreArchivo = element.nombreArchivo;
      const dialogVisroRef = this.dialog.open(VisorPdfDialogComponent, {
        width: '1300px',
        data: modelVisor,
        autoFocus: false,
      });
    }
    else {
      this.solicitudVehiculoDocumentoService.downloadDocumento(
        this.model.codigoSolicitud,
        this.modelVehiculo.idSolicitudVehiculo,
        element.idSolicitudVehiculoDocumento
      ).subscribe(data => {
        let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
        fileSaver.saveAs(blob, element.nombreArchivo);
      });
    }
  }
}
